import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    formContainer: {
        marginTop: theme.spacing(3),
    }
}));
